import { useTranslate } from '@festina-life/ui/hooks'

import { TransferButton } from '../../components/transferButton/TransferButton'
import { useTransferableVersionsInBlock } from '../../hooks/useTransferableVersionsInBlock'
import { useMappingId } from '../../system/useMappingId'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useOperationsContext } from '../../workspace/operationsContext'

/** Transfers every version of the GL map in scope to an ancestor block. */
export const GlMapTransferButton = () => {
  const translate = useTranslate()
  const mappingId = useMappingId()
  const { block } = useNavigationParams()
  const { glMapOperations } = useOperationsContext()

  const transferableOperations = useTransferableVersionsInBlock({
    operationsByBlock: glMapOperations,
    itemId: mappingId,
  })

  return (
    <TransferButton
      item={{
        itemId: mappingId,
        type: 'glMap',
        operationName: mappingId,
        versionCount: transferableOperations.length,
        isTransferable: !!transferableOperations.length,
      }}
      transfer={{
        label: translate('glMapViewer.topBar.actions.transfer'),
        description: translate('transfer.confirmationModal.glMap.description', {
          sourceBlock: block,
        }),
        onConfirm: ({ transfer }) =>
          transfer({
            shouldInvalidateCacheAfterTransfer: true,
            operationName: mappingId,
            operations: transferableOperations,
          }),
      }}
    />
  )
}
